import { useLoyalty } from "@chef/state-management/hooks";
import { CalendarQuery } from "@chef/state-management";
import {
  getBasketFinances,
  getBasketForCalendarWeek,
} from "@chef/state-management/helpers";
import { useCalendarData } from "@chef/state-management/hooks";

export const useFinancesForCalendarWeek = (args: {
  calendarWeek: CalendarQuery["calendar"][number];
}) => {
  const { calendarWeek } = args;

  const { basket } = useCalendarData({
    week: calendarWeek.week,
    year: calendarWeek.year,
  });

  const { data: loyaltyData } = useLoyalty();

  return getBasketFinances({
    basketProducts: [...basket.mealboxBasket, ...basket.groceryBasket],
    customerFee: getBasketForCalendarWeek({ calendarWeek }).mealboxBasket
      ?.shippingDetails.plannedDeliveryInformation.customerFee,
    loyaltyLevel: loyaltyData?.currentLevel,
  });
};
